<template>
    <q-list>
        <q-collapsible icon="far fa-star" :label="$t('featured')" :opened="!$q.platform.is.mobile ? true : false">
            <q-card inline class="text-white q-mr-sm q-mt-sm cursor-pointer" :class="getBg(category.value)" style="width: 150px; height: 150px" v-for="(category, index) in featuredCategories" :key="index" @click.native="clickCategory(category.value)">
                <q-card-media class="text-center q-pt-md">
                    <q-icon :name="category.icon" size="3rem" />
                </q-card-media>
                <q-card-main class="text-center uppercase">
                    {{ category.label }}
                </q-card-main>
            </q-card>
        </q-collapsible>
    </q-list>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            search_store: 'libraries/search',
            categories: 'libraries/categories',
            all_categories: 'libraries/all_categories',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        featuredCategories() {
            let categories = []

            this.all_categories.forEach(category => {
                if (category.featured) categories.push(category)
            })
            return categories
        }
    },

    methods: {
        getBg(id) {
            if (this.categories.find(e => e == id)) return 'bg-secondary'
            else return 'bg-primary'
        },

        clickCategory(id) {
            let categories = Object.assign([], this.categories)

            if (categories.find(category => category == id)) {
                categories = categories.filter(category => category !== id)
            }
            else {
                categories.push(id)
            }

            this.$store.dispatch('libraries/SET_CATEGORIES', [categories])
        }
    }
}
</script>

<style lang="stylus" scoped>

</style>
